
import isNull from 'lodash/isNull'
import settings from '../settings'
export const getRankWrapper = (seasonRank: number) => {
    if (!seasonRank) {
        return 0
    }
    const parsedSeasonRank = parseInt(`${seasonRank}`, 10)
    if (parsedSeasonRank >= 17) {
        return 4
    }
    if (parsedSeasonRank < 17 && parsedSeasonRank >= 8) {
        return 3
    }
    if (parsedSeasonRank < 8 && parsedSeasonRank > 1) {
        return 2
    }
    if (parsedSeasonRank === 1) {
        return 1
    }
}

export const hasSeasonRank = (seasonRank: any, seasonId: any) => {
    return !isNull(seasonRank) && seasonId in settings.seasonNames
}

export const hasAnyRank = (rank: any, seasonRank: any, seasonId: any) => {
    return !isNull(rank) || hasSeasonRank(seasonRank, seasonId)
}